import React from 'react';

export const ActionsHeaderCell = ({ title }) => <th width="30px">{title}</th>;
